import Select, {components, MultiValueRemoveProps} from 'react-select';
import {useState} from 'react';
import {
    Control,
    Path,
    PathValue,
    FieldValues,
    useController,
} from 'react-hook-form';
import {
    customStylesInput,
} from '../../../../configs/components/selectBoxStyle';
import * as styles from './selectBox.module.css';

type SelectOption = {
    id?: string,
    value?: string | number | boolean,
    label?: string,
};

interface IMultiSelectBoxProps<T extends FieldValues> {
    title: string,
    placeholder: string,
    control: Control<T>,
    defaultValue?: PathValue<T, Path<T>>,
    optionsValues?: SelectOption[],
    controllerName: Path<T>,
    required?: boolean,
    canType?: boolean,
    isDisabled?: boolean,
    setValueAs?: (value: SelectOption) => string | number | null,
}

const MultiSelectBox = <T extends Record<string, any>>({
    title,
    placeholder,
    control,
    optionsValues = [],
    controllerName,
    required = false,
    canType = false,
    isDisabled = false,
}: IMultiSelectBoxProps<T>) => {
    const [isLoading] = useState(false);
    const [options, setOptions] = useState(optionsValues);
    const {
        field: {
            name,
            value = [] as string[] | Record<string, any>,
            onChange,
            ref,
        },
    } = useController({
        name: controllerName,
        control,
        rules: {
            required,
        },
    });

    const selectValue = () => optionsValues.filter(item => value.includes(item.id));

    const handleOnChange = (option: SelectOption[] | any) => {
        const lastInput = option[option.length - 1];

        if (option.length > 0 && (!options.includes(lastInput))) {
            setOptions([...options, lastInput]);
        }

        return onChange(option.map((item: SelectOption) => item.id));
    };

    const MultiValueRemove = (props: MultiValueRemoveProps) => (
        <components.MultiValueRemove {...props}>
            ✕
        </components.MultiValueRemove>
    );

    return (
        <span className={styles.inputWrapper}>
            <span className={styles.title}>
                {title}
            </span>
            <Select
                components={{MultiValueRemove}}
                name={name}
                ref={ref} // ref instead of inputRef to fix types, possibly broken?
                styles={customStylesInput}
                isClearable={true}
                isDisabled={isDisabled}
                isLoading={isLoading}
                options={optionsValues}
                value={selectValue() || 'undefined'}
                isSearchable={canType}
                placeholder={placeholder}
                onChange={handleOnChange}
                isMulti={true}
            />
        </span>
    );
};

export default MultiSelectBox;
